import React from 'react';
import Modal from '../Modal';
import * as S from './styled';
import Icon from '../Icon';
import ModalTitle from '../ModalTitle';

const ErrorModal = ({ text, title, ...rest }) => (
  <Modal {...rest} data-blocoid="Modal: Algo deu errado">
    <S.ErrorTitleWrapper>
      <Icon icon="atencao-p" />
      <ModalTitle as="h2" hasIcon title={title} />
    </S.ErrorTitleWrapper>
    <S.ErrorText>{text}</S.ErrorText>
  </Modal>
);

export default ErrorModal;
